import { Main } from '@/components/_common/main';
import { createFileRoute, ErrorComponent } from '@tanstack/react-router';
import { getMemesServer } from '@/lib/blog.server';
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription } from '@/components/ui/dialog';

const Memes = () => {
  const memes = Route.useLoaderData();

  return (
    <Main className="relative my-24 px-4">
      <div className="flex flex-wrap justify-center gap-4">
        {memes.map((meme) => (
          <Dialog key={meme}>
            <DialogTrigger asChild>
              <div className="cursor-pointer max-w-sm overflow-hidden rounded-lg border bg-muted h-min my-auto transition-all hover:scale-[1.02] hover:shadow-md">
                <img
                  src={meme}
                  alt="Meme"
                  className="w-full object-cover"
                  loading="lazy"
                />
              </div>
            </DialogTrigger>
            <DialogContent className="max-w-5xl p-0 overflow-hidden bg-transparent border-none shadow-none">
              <DialogTitle className="sr-only">Meme visualization</DialogTitle>
              <DialogDescription className="sr-only">Full size view of the meme</DialogDescription>
              <img
                src={meme}
                alt="Meme Full"
                className="w-full h-auto max-h-[90vh] object-contain mx-auto"
              />
            </DialogContent>
          </Dialog>
        ))}
      </div>
    </Main>
  );
};

export const Route = createFileRoute('/memes')({
  errorComponent: ErrorComponent,
  component: Memes,
  loader: async () => {
    return await getMemesServer();
  },
});
